import FormActionTypes from '../../constants/form_action_types';
import FormAction from './form_action';
import LinkFormAction from './link_form_action';
import SearcherFormAction from './searcher_form_action';
import SubmitFormAction from './submit_form_action';
import GridFormAction from './grid_form_action';

export const create = (formActionProps) => {
	const formActionClass = getModelClass(formActionProps.type);
	return new formActionClass(formActionProps);
};

export const getModelClass = (formActionType) => {
	switch(formActionType) {
		case FormActionTypes.LINK:
			return LinkFormAction;
		case FormActionTypes.SEARCHER:
			return SearcherFormAction;
		case FormActionTypes.SUBMIT:
			return SubmitFormAction;
		case FormActionTypes.GRID:
			return GridFormAction;
		default:
			return FormAction;
	}
};

export default {
	create,
	getModelClass,
};
